export const GITHUB_URL = 'https://github.com/bookwormio/bookworm';